/**
 * Converts currency codes to their symbols
 * @param currencyCode - ISO currency code (e.g., 'USD', 'GBP', 'EUR')
 * @returns Currency symbol (e.g., '$', '£', '€')
 */
export function getCurrencySymbol(currencyCode: string): string {
  const currencyMap: { [key: string]: string } = {
    'USD': '$',
    'GBP': '£',
    'EUR': '€',
    'JPY': '¥',
    'CNY': '¥',
    'CAD': 'CA$',
    'AUD': 'A$',
    'CHF': 'CHF',
    'SEK': 'kr',
    'NOK': 'kr',
    'DKK': 'kr',
    'INR': '₹',
    'BRL': 'R$',
    'MXN': 'MX$',
    'ZAR': 'R',
    'KRW': '₩',
    'SGD': 'S$',
    'HKD': 'HK$',
    'NZD': 'NZ$',
  };

  const upperCode = currencyCode.toUpperCase();
  return currencyMap[upperCode] || upperCode;
}

/**
 * Formats a price with currency symbol
 * @param amount - The amount (can be in cents or actual price)
 * @param currencyCode - ISO currency code
 * @param inCents - Whether the amount is in cents (default: true)
 * @returns Formatted price string (e.g., '£99.99')
 */
export function formatPrice(amount: number, currencyCode: string, inCents: boolean = true): string {
  const price = inCents ? amount / 100 : amount;
  const symbol = getCurrencySymbol(currencyCode);
  return `${symbol}${price.toFixed(2)}`;
}
